import { Box, Divider } from "@mantine/core";
import { TopSection } from "./TopSection";
import { VersionInfo } from "./VersionInfo";
import classes from "./Sidebar.module.css";
import { Logout } from "../logout";

export interface SidebarProps {
    /** the function for closing the sidebar */
    toggle: () => void;
}

export function Sidebar({ toggle }: SidebarProps) {
    return (
        <Box className={classes.sidebar} component="nav">
            <Box p="lg">
                <TopSection toggle={toggle} />
            </Box>
            <Box className={classes.sidebarMiddleSection}>{/* here we can implement the middle section of the nav bar */}</Box>
            <Divider />
            <Box p="md" className={classes.sidebarBottomSection}>
                <Logout />
            </Box>
            <VersionInfo />
        </Box>
    );
}
